<template>
  <div class="company-status-select-wrapper">
    <select
      :value="props.modelValue"
      @change="handleChange"
      class="company-status-select"
      :class="getStatusClass(props.modelValue)"
    >
      <option
        v-for="status in statusOptions"
        :key="status.value"
        :value="status.value"
        :class="getStatusClass(status.value)"
      >
        {{ status.label }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { CompanyStatus } from '../../../commons/src/groups-management/utils/company-status'

interface Props {
  modelValue: CompanyStatus
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: CompanyStatus]
}>()

const statusOptions = Object.values(CompanyStatus).map((status) => ({
  value: status,
  label: status,
}))

const handleChange = (event: Event) => {
  const target = event.target as HTMLSelectElement
  emit('update:modelValue', target.value as CompanyStatus)
}

const getStatusClass = (status: CompanyStatus) => {
  const statusMap: Record<CompanyStatus, string> = {
    [CompanyStatus.ACTIVA]: 'status-activa',
    [CompanyStatus.EN_RENOVACION]: 'status-en-renovacion',
    [CompanyStatus.NO_RENOVADA]: 'status-no-renovada',
    [CompanyStatus.SUSPENDIDA]: 'status-suspendida',
    [CompanyStatus.CANCELADA]: 'status-cancelada',
    [CompanyStatus.NO_ASIGNADA]: 'status-no-asignada',
  }
  return statusMap[status] || 'status-no-asignada'
}
</script>

<style scoped>
.company-status-select-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.company-status-select {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 7px;
  width: 197px;
  height: 40px;
  border: 1px solid #c5c5c5;
  border-radius: 4px;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
  padding-right: 32px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath fill='none' stroke='%23696969' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M2 2l4 4 4-4'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px 8px;
}

.company-status-select:hover {
  border-color: #a1a1a1;
}

.company-status-select:focus {
  border-color: #003286;
}

/* Status colors */
.company-status-select.status-activa {
  color: #4eab1f;
}

.company-status-select.status-en-renovacion {
  color: #003286;
}

.company-status-select.status-no-renovada {
  color: #ff8409;
}

.company-status-select.status-suspendida {
  color: #b47e08;
}

.company-status-select.status-cancelada {
  color: #d0342c;
}

.company-status-select.status-no-asignada {
  color: #a1a1a1;
}

.company-status-select option {
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  padding: 8px;
}

.company-status-select option.status-activa {
  color: #4eab1f;
  background-color: #ffffff;
}

.company-status-select option.status-en-renovacion {
  color: #003286;
  background-color: #ffffff;
}

.company-status-select option.status-no-renovada {
  color: #ff8409;
  background-color: #ffffff;
}

.company-status-select option.status-suspendida {
  color: #b47e08;
  background-color: #ffffff;
}

.company-status-select option.status-cancelada {
  color: #d0342c;
  background-color: #ffffff;
}

.company-status-select option.status-no-asignada {
  color: #a1a1a1;
  background-color: #ffffff;
}
</style>
